import type { Components, Theme } from '@mui/material'

export const OmuiSegmentedControl: NonNullable<Components['OmuiSegmentedControl']> = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.futureTheme.bg.surface.inset,
      borderRadius: theme.shape['futureTheme.radius-lg'],
      padding: theme.spacing(0.5),
      gap: theme.spacing(0.5),
      '& .MuiToggleButton-root': {
        borderRadius: theme.shape['futureTheme.radius-md'],
        backgroundColor: theme.palette.futureTheme.bg.invisible,
        color: theme.palette.futureTheme.text.muted,
        ...theme.typography['futureTheme.body-medium'],
        padding: theme.spacing(1, 2.5),
        border: 'none',
        '&:hover': {
          color: theme.palette.futureTheme.text.default,
          backgroundColor: theme.palette.futureTheme.bg.invisible,
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.futureTheme.bg.surface.elevated,
          color: theme.palette.futureTheme.text.default,
          boxShadow: theme.futureTheme.shadows.xs,
          '&:hover': {
            backgroundColor: theme.palette.futureTheme.bg.surface.elevated,
          },
        },
        // Space next to icon (assume badge at start), unless icon only
        '& .MuiSvgIcon-root:first-child': {
          marginRight: theme.spacing(1),
          '&:last-child': {
            marginRight: 0,
          },
        },
        // Space next to badge (assume badge at end)
        '& .OmuiCountBadge-root:last-child': {
          marginLeft: theme.spacing(1),
        },
      },
      // MUI's default grouped spacing would otherwise fight the gap
      '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': { marginLeft: 0 },
    }),
  },
}
export const MuiToggleButton: Components<Omit<Theme, 'components'>>['MuiToggleButton'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
  },
}
